<blaze-panel>
  <div icon class="icon-settings"></div>

  <div title>Setup Shopify</div>

  <ng-container actions>
    <blaze-environment-indicator class="mr-6" />
  </ng-container>

  <div content class="dialog-content">
    @if (isAfterAuthorization) {
      <form class="form" (ngSubmit)="requestAccess()" [formGroup]="accessForm">
        <label class="field-label bd-field-label required">Name Your Connector</label>
        <input
          formControlName="connectorName"
          name="connectorName"
          class="bd-text-input tall"
          required
        />
        <button type="submit" blazeButton class="submit-btn mt-16">Create connector</button>
      </form>
    } @else {
      <div class="flex flex-col items-center">
        <h3 class="mb-16">To proceed you need to install Blaze App in Shopify app</h3>
        <button blazeButton class="go-to-shopify-btn" (click)="goToShopify()">
          Go to Shopify
        </button>
      </div>
    }
  </div>
</blaze-panel>
